import React, { useEffect, useState, useContext } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import { collection, doc, getDoc, onSnapshot, query, where } from "firebase/firestore"
import { useHistory, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import UserOrderTable from '../../../components/table/UserOrderTable'
import { AuthContext } from "../../../context/AuthContext";

const Single = () => {

  
  const { currentUser } = useContext(AuthContext)

  const user = currentUser.uid;


  const [ adminData, setAdminData ] = useState("")

  const [ adminInfo, setAdminInfo] = useState([])

  const getAdmin = async() => {

      const docRef = doc(db, "admins", user);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setAdminData( docSnap.data())
        // console.log(userData)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
  }

  useEffect(()=>{
    getAdmin()
  }, [])


  console.log('current user: ', currentUser)

  console.log('adm: ', user)




  //  useEffect(() => {


  //     const q = query(collection(db, "admins"), where("adminId", "==", user));

  //     const unsubscribe = onSnapshot(q, (querySnapshot) => {

  //     const list = [];

  //     querySnapshot.forEach((doc) => {

  //         list.push({id: doc.id, ...doc.data()});

  //     });

  //     setAdminInfo(list)


  //     });

  //     return () => unsubscribe();

  // }, []);


  // useEffect(() => {
    
  //   //LISTEN REAL TIME

  //   const orderQuery = async() => {

  //     const orderRef = (collection(db, "order"));
  //     const q = query(orderRef, where("userId", "==", customerId));

  //     const querySnapshot = await getDocs(q);
  //       let list = []
  //     querySnapshot.forEach((doc) => {
  //       // doc.data() is never undefined for query doc snapshots
  //       list.push(doc.data())
  //       // console.log(doc.id, " => ", doc.data());
  //       console.log(list)

  //       setOrderData(list)
  //       // console.log(orderData)
  //     });

  //     // setOrderData(doc.data())
  //     // console.log(orderData)

  //   }
    
  //   orderQuery()   
  // },[])
 

  return (
    <div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 className='title'>Admin Information</h2>
            <div className='item'>
            <img
                src = {adminData.img ? adminData.img : "../images/user.png"}
                alt="avatar"
                style={{width:'100px', height:'100px', borderRadius:'50%'}}
                   
            /> 
              

          
               
                <div className="details">
                  <h3 className='itemTitle'>{adminData.email}</h3>
                  <div className='detailItem'>
                    <span className='itemKey'>Full Name:</span>
                    <span className='itemValue'>{adminData.lastname} {adminData.firstname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Role:</span>
                    <span className='itemValue'>{adminData.role === "adminAccess" ? 'Admin' : adminData.role === "subadminAccess" ? "Sub Admin" : "Agency"}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Status:</span>
                    <span className='itemValue'>{adminData.status}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Registered Date:</span>
                    <span className='iitemValue'>{adminData.date}</span>
                  </div>
                   <div className='detailItem'>
                    <span className='itemKey'>Telephone:</span>
                    <span className='iitemValue'>{adminData.telephone}</span>
                  </div>
                </div>
            </div>
          </div>
          {/* <div>
            <Chart 
              aspect={3/1}
              title = "Customer purchase last 6 months"
            />
          </div> */}
        </div>
        {/* <div className="bottom">
        <div className='listTitle'>Customer Transactions History</div>
          <UserOrderTable
                customerId = {customerId}
          />
        </div> */}
      </div>
    </div>
  )
}

export default Single